enum DeliverStatus {
  SENDING = 'SENDING',
  QUEUED = 'QUEUED',
  DELIVERED = 'DELIVERED',
}

export default DeliverStatus;
